const name = "streaming";
export default name;
